import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ currentPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPastHero, setIsPastHero] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setIsScrolled(y > 50);
      // Pasado el hero (100vh aprox) el fondo es claro
      setIsPastHero(y > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Array de páginas para la navegación
  const navPages = [
    { id: 'inicio', label: 'Inicio', path: '/' },
    { id: 'servicios', label: 'Servicios', path: '/servicios' },
    { id: 'nosotros', label: 'Nosotros', path: '/nosotros' },
    { id: 'contacto', label: 'Contacto', path: '/contacto' }
  ];

  // Función para manejar click en navegación
  const handleNavClick = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false); // Cerrar menú móvil si está abierto
    
    // Scroll al inicio después de navegar
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // Función para manejar click en logo
  const handleLogoClick = () => {
    navigate('/');
    // Scroll al inicio después de navegar al home
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  // Toggle menú móvil
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''} ${isPastHero ? 'header--light' : ''}`}>
      <nav className="nav">
        {/* Logo */}
        <div className="nav__logo" onClick={handleLogoClick}>
          <img src="/logobien.png" alt="ISQS Services" className="nav__logo-img" />
        </div>

        {/* Navegación Desktop */}
        <ul className="nav__links">
          {navPages.map((page) => (
            <li key={page.id} className="nav__item">
              <button
                type="button"
                onClick={() => handleNavClick(page.path)}
                className={`nav__link ${currentPage === page.id ? 'nav__link--active' : ''}`}
              >
                {page.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Botón Menú Móvil */}
        <button 
          className={`nav__mobile-toggle ${isMobileMenuOpen ? 'nav__mobile-toggle--open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Menú Móvil */}
        <div className={`nav__mobile-menu ${isMobileMenuOpen ? 'nav__mobile-menu--open' : ''}`}>
          <ul className="nav__mobile-links">
            {navPages.map((page) => (
              <li key={page.id} className="nav__mobile-item">
                <button
                  type="button"
                  onClick={() => handleNavClick(page.path)}
                  className={`nav__mobile-link ${currentPage === page.id ? 'nav__mobile-link--active' : ''}`}
                >
                  {page.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Overlay para cerrar menú móvil */}
      {isMobileMenuOpen && (
        <div 
          className="nav__overlay" 
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;